import React from 'react';
import { Button, SparkIcon } from '@spark';
import { TOOL_SOURCE_TYPE_META } from './agentConfigModel';

/**
 * Shell of one Tool Discovery card (Figma 3926-8787): white bordered card,
 * header row with the source icon, title and a trash icon button separated
 * by a bottom border, then the type-specific body.
 */
const ToolSourceCard = ({ type, onRemove, children, className = '' }) => {
    const meta = TOOL_SOURCE_TYPE_META[type];
    return (
        <section
            className={`cw-ac-source-card ${className}`.trim()}
            data-source-type={type}
            aria-label={`${meta.cardTitle} tool source`}
        >
            <header className="cw-ac-source-card__header">
                <div className="cw-ac-source-card__title">
                    <span className="cw-ac-source-card__icon">
                        <SparkIcon slug={meta.iconSlug} size="medium" />
                    </span>
                    <span className="cw-ac-source-card__title-text">{meta.cardTitle}</span>
                </div>
                <Button
                    size="tiny"
                    variant="ghost"
                    icon={<SparkIcon slug="trash" size="small" />}
                    aria-label={`Remove ${meta.cardTitle}`}
                    onClick={onRemove}
                    className="cw-ac-source-card__remove"
                />
            </header>
            <div className="cw-ac-source-card__body">{children}</div>
        </section>
    );
};

export default ToolSourceCard;
